const PHOTO_DROP_SURFACE_SELECTOR =
  '[data-testid="center-canvas-pasteboard"], [data-photo-placement-target="true"]'

const PHOTO_DROP_BLOCKED_ANCESTOR_SELECTOR = [
  '[data-left-panel="true"]',
  '[data-right-panel-shell="true"]',
  '[data-right-panel-rail="true"]',
].join(', ')

/** True when the pointer is over the canvas pasteboard / spread, not editor side panels. */
export function isClientPointOverPhotoDropSurface(clientX: number, clientY: number): boolean {
  if (!Number.isFinite(clientX) || !Number.isFinite(clientY)) return false

  const target = document.elementFromPoint(clientX, clientY)

  if (!target) return false
  if (target.closest(PHOTO_DROP_BLOCKED_ANCESTOR_SELECTOR)) return false

  return target.closest(PHOTO_DROP_SURFACE_SELECTOR) != null
}
